import React from "react";

const CoberturaSalud = (props) => {
  window.scrollTo(0, 0);

  return (
    <section className="sobre-pedraza condiciones-contratacion coberturaSalud">
      <div className="container">
        <div className="row">
          <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h1>Cobertura de Salud</h1>
            <hr />
            <p>
              En todos los destinos contratados a{" "}
              <strong>Pedraza Viajes y Turismo S.A</strong> los pasajeros
              cuentan con la cobertura médica de la empresa{" "}
              <strong>Assist Travel S.A</strong> conforme las franquicias
              correspondientes que abajo se explicitan. Ponemos en su
              conocimiento que queda exceptuada de la cobertura médica el{" "}
              <strong>Día de Campo en la Estancia La Margarita</strong>.
            </p>

            <h6>Detalle del Servicio de Assist Travel (Alcance Nacional)</h6>
            <ul>
              <li>
                Asistencia medica en caso de accidente <strong>$445.231</strong>
              </li>
              <li>
                Asistencia medica en caso de enfermedad{" "}
                <strong>$445.231</strong>
              </li>
              <li>
                Medicamentos Ambulatorios <strong>$32.596</strong>
              </li>
              <li>
                Odontología <strong>$22.040</strong>
              </li>
              <li>
                Asistencia Medica por COVID19 <strong>Incluida</strong>
              </li>
              <li>
                Video Consulta Medica <strong>Incluida</strong>
              </li>
            </ul>
            <br />
            <h6>Detalle del Servicio de Assist Travel (Alcance Regional)</h6>
            <ul>
              <li>Asistencia medica en caso de accidente  <strong>U$D6.000</strong></li>
              <li>Asistencia medica en caso de enfermedad  <strong>U$D6.000</strong></li>
              <li>Medicamentos Ambulatorios  <strong>U$D500</strong></li>
              <li>Odontología  <strong>U$D500</strong></li>
              <li>Asistencia Medica por COVID19 Incluida</li>
              <li>Video Consulta Medica Incluida</li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
};

export default CoberturaSalud;



// WEBPACK FOOTER //
// ./src/components/Global/coberturaSalud.js